let baseUrl = "";

let qa = "http://specialty-api1.qa.elong.com";
let stage = "http://specialty-api-hd.elong.com";
let prod = "https://arsenalgw.elong.com/specialty";

let env = process.env.curEnv === "prod" ? "prod" : "qa";
// let env = 'stage';
// let env = 'qa';

if (env === "qa") {
    baseUrl = qa;
}

if (env === "stage") {
    baseUrl = stage;
}

if (env === "prod") {
    baseUrl = prod;
}

export default {
    baseUrl
};
